import React from 'react'
import classNames from 'classnames'
import Icon from '../../atoms/icon/Icon'
import { useDropzone } from 'react-dropzone'

import './FileDropZone.scss'
import LoadingSpinner from '../../atoms/loadingspinner/LoadingSpinner'

interface Props {
  className?: string
  onDrop: (acceptedFiles: Array<File>) => void
  accept?: string
  dropzoneText?: string
  dropzonePlaceholderMain?: string
  dropzonePlaceholderSecondary?: string
  required?: boolean
  isLoading?: boolean
}

export const FileDropZone: React.FC<Props> = ({
  className,
  onDrop,
  accept,
  dropzoneText,
  dropzonePlaceholderMain,
  dropzonePlaceholderSecondary,
  required = true,
  isLoading = false,
}) => {
  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: accept })
  
  if (isLoading) {
    return <div className={classNames('dropzone', className,{ errorActive: 'red-border-error' })}>
      <LoadingSpinner />
    </div>
  }

  return <div {...getRootProps({ className: classNames('dropzone', className,{ errorActive: 'red-border-error' }) })}>
    <input {...getInputProps()} data-test='dropzone' required={required} />
    <div className='upload-text-container'>
      <div className='upload-text-item'>
        <Icon type='upload' className='upload-icon' />
        {!dropzoneText && <div>{dropzonePlaceholderMain || 'Upload files here'}</div>}
      </div>
      {!dropzoneText && <div className='upload-text-secondary'>{dropzonePlaceholderSecondary || ''}</div>}
    </div>
    {!!dropzoneText && <div className='uploaded-file'>{dropzoneText}</div>}
  </div>
}